import history from './router-history'

export const push = path => history.push(path)

export const replace = path => history.replace(path)
